// Shared helpers for the mobile companion app (isolated under /m).
export const money = (n, cur = "CAD") =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: cur || "CAD" }).format(Number(n || 0));

export const monthKey = (d = new Date()) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  return `${y}-${m}`;
};

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const prettyDate = (s) => {
  if (!s) return "";
  const iso = s.length <= 10 ? `${s}T00:00:00` : s;
  const d = new Date(iso);
  if (isNaN(d)) return s;
  return d.toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" });
};

export const prettyMonth = (key) => {
  if (!key) return "";
  const [y, m] = key.split("-");
  return new Date(Number(y), Number(m) - 1, 1).toLocaleDateString("en-CA", { month: "long", year: "numeric" });
};

export const timeAgo = (s) => {
  if (!s) return "";
  const d = new Date(s.length <= 10 ? `${s}T00:00:00` : s);
  const secs = Math.floor((Date.now() - d.getTime()) / 1000);
  if (secs < 60) return "just now";
  if (secs < 3600) return `${Math.floor(secs / 60)}m ago`;
  if (secs < 86400) return `${Math.floor(secs / 3600)}h ago`;
  if (secs < 604800) return `${Math.floor(secs / 86400)}d ago`;
  return d.toLocaleDateString("en-CA", { month: "short", day: "numeric" });
};

export const initials = (name) =>
  (name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
